import { render } from "./Qualitaet.vue?vue&type=template&id=f58c678c"
import script from "./Qualitaet.vue?vue&type=script&lang=js"
export * from "./Qualitaet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__